// Single source for the status tag and negative-amount colours, so the mobile
// list, the detail views and the desktop table stay in step with the design.
const HOLD_COLORS = { bg: "#fdf5e9", fg: "#9f6e1a" };

const STATUS_PALETTE = {
  paid: { bg: "#edfaf1", fg: "#009a51" },
  adjusted: { bg: "#edfaf1", fg: "#009a51" },
  "paid (adjusted)": { bg: "#edfaf1", fg: "#009a51" },
  upcoming: { bg: "#e8eaf5", fg: "#3c4886" },
  "carry forward": { bg: "#fff1e6", fg: "#e86c37" },
  hold: HOLD_COLORS,
  retry: HOLD_COLORS,
};

const FALLBACK_STATUS_COLORS = { bg: "#f2f4f7", fg: "#596378" };

export const statusColors = (status) =>
  STATUS_PALETTE[(status || "").toLowerCase()] || FALLBACK_STATUS_COLORS;

export const NEGATIVE_AMOUNT_COLOR = "#ef4f5f";
